import { API, graphqlOperation } from "aws-amplify";
import GraphContent from "../components/graphContent/graph_content";
import SignalContent from "../components/signalContent/signal_content";

const authStoreItems = `user_id
store_name
accessKey
secretKey
region`;

export default class AuthStoreAPI {
  /**
   * 認証ストア情報取得
   * @param userID
   */
  public static async query(userID: string) {
    const queryBody = `
      query getAuthStores {
        qureyIotKyotoAuthStore(user_id: "${userID}") {
          items {
            ${authStoreItems}
          }
        }
      }
    `;
    const result: any = await API.graphql(graphqlOperation(queryBody));
    return result.data.qureyIotKyotoAuthStore.items;
  }

  /**
   * storeNameを指定して認証ストア情報取得
   * @param userID
   * @param storeName
   */
  public static async queryFromStoreName(userID: string, storeName: string) {
    const queryBody = `
      query getAuthStoresFromStoreName {
        qureyIotKyotoAuthStoreFromStoreName(
          user_id: "${userID}",
          store_name: "${storeName}"){
          items {
            ${authStoreItems}
          }
        }
      }
    `;
    const result: any = await API.graphql(graphqlOperation(queryBody));
    return result.data.qureyIotKyotoAuthStoreFromStoreName.items[0];
  }

  public static async create(self: GraphContent | SignalContent) {
    const inputBody = `
      mutation putAuthStore {
        putAuthStoreFunction(
          input: {
            user_id: "${self.userID}",
            store_name: "${self.newStoreName}",
            accessKey: "${self.newAccessKey}",
            secretKey: "${self.newSecretKey}",
            region: "${self.newRegion}"
          }
        ) {
          ${authStoreItems}
        }
      }
    `;
    const result: any = await API.graphql(graphqlOperation(inputBody));
    return result.data.putAuthStoreFunction;
  }

  /**
   * storeNameを指定して認証ストア情報取得(初期設定フロー)
   * @param self
   */
  public static async createDefaultSetting(self: GraphContent) {
    const inputBody = `
      mutation putAuthStore {
        putAuthStoreFunction(
          input: {
            user_id: "${self.userID}",
            store_name: "${self.inputAuth}",
            accessKey: "${self.newDefaultSettingAccessKey}",
            secretKey: "${self.newDefaultSettingSecretKey}",
            region: "${self.newDefaultSettingRegion}"
          }
        ) {
          ${authStoreItems}
        }
      }
    `;
    const result: any = await API.graphql(graphqlOperation(inputBody));
    return result.data.putAuthStoreFunction;
  }

  /**
   * 認証ストア削除
   * @param userID
   * @param storeName
   */
  public static async delete(userID: string, storeName: string) {
    const deleteBody = `
      mutation delete {
        deleteIotKyotoAuthStore(
          input: {
            user_id: "${userID}",
            store_name: "${storeName}"
          }
        ) {
          user_id
          store_name
        }
      }
    `;
    const result: any = await API.graphql(graphqlOperation(deleteBody));
    return result.data.deleteIotKyotoAuthStore;
  }
}
